import {useDomainConfig} from '../../../../provider/domain-config/domain-config-hook';
import {useUser} from '../../../../provider/user/user-hook';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {ProvidersIdsEnum} from '../../../../util/type';

import {YandexStoriesWidget} from './yandex-stories-widget';

export function YandexStories(): JSX.Element | null {
    const {user} = useUser();
    const {regionAvailableCatalogs} = user || {};
    const {isDomainFeatureEnabled} = useDomainConfig();

    if (isDomainFeatureEnabled[FeaturesEnum.yandexStories] && regionAvailableCatalogs?.[ProvidersIdsEnum.yandex]) {
        return <YandexStoriesWidget />;
    }

    return null;
}
